import { _ } from "../../core/polyglot/polyglot.js";
import { formatForceTwoDecimals } from "../../core/helpers/count-formatting-util.js";
import { makeMonitorRepository } from "../../core/repositories/repositoryBuilders.js";
import accountingDocument from "../shared/accountingDocument.js";
import ArrayStream from "../../core/list/streams/ArrayStream.js";
import InvoiceGroup from "../../models/accounting/invoices/InvoiceGroup.js";
import ListSource from "../../core/list/ListSource.js";
import makeTableListWidget from "../../core/widgets/list/TableListWidget/makeTableListWidget.js";
import session from "../../core/session.js";

/**
 * Dislay receivable and payable `invoiceGroup`.
 *
 * @abstract
 */
export default accountingDocument.abstractSubclass((that, my) => {
	my.initialize = function () {
		my.super(...arguments);

		my.company = session.getCompany();
		my.repository = my.getRepository();
	};

	my.initializeSubwidgets = function () {
		my.super(...arguments);

		that.help = my.buildHelp();
	};

	that.show = async function () {
		const invoiceGroup = await my.repository.get();

		const listSource = ListSource.makeAndFetch({
			stream: new ArrayStream({ data: invoiceGroup.getInvoices() }),
		});

		my.invoiceGroupWidget = makeTableListWidget({
			columnSpecifications: my.getColumnSpec(),
			tfootRenderer: () => my.tfootRenderer({ invoiceGroup }),
			source: listSource,
			striped: true,
		});

		that.update();
	};

	that.hasActionsMenu = function () {
		return false;
	};

	my.renderContentOn = function (html) {
		if (!my.invoiceGroupWidget) return;

		html.render(
			my.section({
				content: html.div(
					{ klass: "responsive-table invoice-report" },
					my.invoiceGroupWidget,
				),
			}),
		);
	};

	my.getRepository = function () {
		return makeMonitorRepository({
			route: my.getRepositoryRoute(),
			model: InvoiceGroup,
			defaultFilters: {
				companyId: my.company.getLegacyId(),
			},
			antiForgeryToken: session.getAntiForgeryToken(),
		});
	};

	my.getRepositoryRoute = function () {
		return my.subclassResponsibility();
	};

	my.getColumnSpec = function () {
		return my.subclassResponsibility();
	};

	my.getHelpMessage = function () {
		return my.subclassResponsibility();
	};

	my.buildHelp = function () {
		return {
			summary: my.getHelpMessage(),
		};
	};

	my.tfootRenderer = function ({ invoiceGroup }) {
		return (html) =>
			html.tr(
				html.th(_("Total")),
				my
					.getColumnSpec()
					.slice(1) // Remove 1st column which has been hijacked by the 'Total' cell.
					.map((column) => {
						let value;
						const currentColumn = column.getSortCriterion();

						if (currentColumn === "convertedBalance") {
							value = invoiceGroup.getBalance();
						} else if (currentColumn === "convertedTotal") {
							value = invoiceGroup.getTotal();
						}

						if (value === undefined) {
							return html.td();
						}
						return html.td(
							{ klass: "text-right" },
							formatForceTwoDecimals(value),
						);
					}),
			);
	};
});
